export const customStyles = {
    rows: {
        style: {
            minHeight: '5.6rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            border: '1px solid #E7EBEE',
            marginTop: '0.7rem',
            color: '#6E7985'
        },
    },
    headRow: {
		style: {
            color: '#181D27',
            fontWeight: '400',
            fontSize: '1.4rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            border: 'none',
            minHeight: 'auto'
		},
	}
}

export const customHeadStyles = {
    headCells: {
        style: {}
    }
}